import Cookies from "js-cookie";

export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    return payload.exp < now; // Compare expiration time with the current time
  } catch (error) {
    console.error('Invalid token:', error);
    return true; // Consider the token expired if decoding fails
  }
}

export function setUserDetails(token){
  const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload
  const userDetails = JSON.parse(payload.sub); // Parse nested JSON in 'sub'
  localStorage.setItem("token", token);
  localStorage.setItem("name", userDetails.name);
  localStorage.setItem("firstName", userDetails.firstName);
  localStorage.setItem("email", userDetails.email);
  localStorage.setItem("userId", userDetails.userId);
  localStorage.setItem("role", userDetails.role);

}

export function clearToken() {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('unifitoken');
}



// WEBPACK FOOTER //
// ./src/untils/authTokenUtils.js